/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropdownFilter/view.blocks to change it.
import InputSmall from 'DesignSystem/InputSmall/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DropdownFilter({
  children,
  viewPath = "/DesignSystem/DropdownFilter",
  backgroundColor = "#ffffff",
  disabled,
  isInvalid,
  height,
  maxWidth = 200,
  minWidth = 200,
  onBlur,
  onChangeFilter,
  onClickShow,
  onCopy,
  onKeyDown,
  onPaste,
  value,
  valueWidth = 510,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  fontSize,
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  isMultiChoice,
  isShowing,
  text
  
}) {
  return (<React.Fragment
>
<InputSmall
  viewPath={`${viewPath}/InputSmall`}
 autoComplete="off"
 backgroundColor={backgroundColor}
 color="#161616"
 disabled={disabled}
 isInvalid={isInvalid}
 height={height}
 maxWidth={maxWidth}
 minWidth={minWidth}
 onBlur={onBlur}
 onChange={onChangeFilter}
 onFocus={onClickShow}
 onCopy={onCopy}
 onKeyDown={onKeyDown}
 onPaste={onPaste}
 placeholder="Filter"
 value={!isShowing ? text : value}
 width={valueWidth}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={isMultiChoice ? "35px" : paddingRight}
 paddingTop={paddingTop}
 fontSize={fontSize}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
/>
{children}
</React.Fragment>)
}